export const websocketsEmitActionTypes = {
    WEBSOCKET_EMIT_DEVICE_TYPE: "deviceType",
    WEBSOCKET_EMIT_CURRENT_STEP: "currentStep",
    WEBSOCKET_EMIT_USER_CURRENT_STEP: "userCurrentStep",
    WEBSOCKET_EMIT_USER_STEP_RECONNECTION: "userStepReconnection",
    WEBSOCKET_EMIT_SHOW_DANGER: "showDanger",
}

export const websocketsOnActionTypes = {
    WEBSOCKET_ON_CREATE_ROOM: "createRoom",
    WEBSOCKET_ON_CONNECT_TO_ROOM: "connectToRoom",
    WEBSOCKET_ON_DISCONNECT_TO_ROOM: "disconnectToRoom",
    WEBSOCKET_ON_POSITION: "position",
    WEBSOCKET_ON_LIGHTON: "isLightOn",
    WEBSOCKET_ON_SLIDER_VALUE: "sliderValue",
    WEBSOCKET_ON_TAP_VALUE: "tapValue",
    WEBSOCKET_ON_PHONE_DATA: "phoneData",
    WEBSOCKET_ON_INTRO_PROGRESSION: "introProgression",
    WEBSOCKET_ON_FINGERPRINT: "fingerprint",
    WEBSOCKET_ON_CODE: "code",
    WEBSOCKET_ON_HANDLE: "handle",
}
